/*
 * service_packages.sp_included_serv_en is one comma-separated string
 * ("Pre-rinse,Foam wash,Microfiber dry"). The mobile API hands it to the app
 * unchanged and the app splits it on commas, so the form edits it as chips but
 * must save it back in exactly that shape.
 */

const cleanList = (items) => items.map((item) => String(item ?? '').trim()).filter(Boolean);

// Stored string (or pasted text) -> chips. New lines count as separators so a
// list pasted one-per-line becomes separate chips too.
export const parseIncludedServices = (value) => cleanList(String(value ?? '').split(/,|\r?\n/));

// Chips -> stored string, no space after the commas, matching the seeded rows.
export const joinIncludedServices = (tags) => cleanList(tags).join(',');
